var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSelectionChevronMedium = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 50"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF2100",
  d: "M14 35.566 28 50V5a5 5 0 0 0-5-5H5a5 5 0 0 0-5 5v44.998z"
})));
export default SvgIconSelectionChevronMedium;